<ng-template hrSlide></ng-template>
